import {createPathRegex} from 'utils/create-path-regex';

import {adminRoutePaths} from '../routes/route-paths';

/** Shared constants used by admin screens and refresh logic. */
export const adminUserPathNameForRefresh: Array<RegExp> = [createPathRegex(adminRoutePaths.usersDetail)];

/** Sentinel value used to represent the "all" option in admin selects. */
export const allOptionValue = Number.MAX_SAFE_INTEGER;

/** Shared array wrapper for the admin "all" sentinel option. */
export const allOptionValueArray = [allOptionValue];
